import { useCallback, useContext } from 'react';
import { get } from 'lodash';

import { PageTranslationContext } from '@providers/ContentfulTranslationsProvider';

import { useTranslate } from './useTranslate';

/**
 * Gets custom translation utilities for a Contentful object. Uses translations from `PageTranslationContext` or
 * from optional `customTranslationsOverride` property.
 *
 * @param customTranslationsOverride Uses this for translations if provided.
 */
export const useCustomTranslations = (
  customTranslationsOverride?: Record<string, string>
) => {
  const pageTranslationContext = useContext(PageTranslationContext);

  const customTranslationFn = useCallback(
    (translationKey: string) =>
      get(customTranslationsOverride ?? pageTranslationContext, translationKey),
    [customTranslationsOverride, pageTranslationContext]
  );

  return {
    /** Gets a translation from provided `customTranslationsOverride` prop or `pageTranslationContext` */
    t: customTranslationFn,
    /** Gets individual translations from Contentful. Same as `useTranslate().t` */
    tContentful: useTranslate().t,
  };
};
